import React from 'react'

import Grid, { Col } from '../../../../../components/pdf/Grid'
import Image from '../../../../../components/pdf/Image'
import Text from '../../../../../components/pdf/Text'
import Link from '../../../../../components/pdf/Link'
import Separator from '../../../../../components/pdf/Separator'
import { useReplies } from '../../_load/ServiceOrderLoader'
import { findReplyByQuestionId, formatEnglishCompleteDate, getReplyValue } from '../../_helpers/pdfHelpers'

const Header = () => {
  const replies = useReplies()

  const date = formatEnglishCompleteDate(getReplyValue(findReplyByQuestionId(replies, 266)))
  const billTo = getReplyValue(findReplyByQuestionId(replies, 262))
  const billToAddress = getReplyValue(findReplyByQuestionId(replies, 263))
  const shipTo = getReplyValue(findReplyByQuestionId(replies, 264))
  const shipToAddress = getReplyValue(findReplyByQuestionId(replies, 265))
  const ourRef = getReplyValue(findReplyByQuestionId(replies, 267))
  const payment = getReplyValue(findReplyByQuestionId(replies, 268))
  const invoiceAccount = getReplyValue(findReplyByQuestionId(replies, 269))
  const termsOfDelivery = getReplyValue(findReplyByQuestionId(replies, 270))

  return (
    <>
      <Grid direction="row" gutter={5} align="stretch">
        <Col gutter={5} style={{ display: 'flex' }}>
          <Grid direction="column" gutter={5} align="center">
            <Col gutter={20}>
              <Separator weight={30} />
              <Image src="/pdfs/axon/axon-logo.svg" maxWidth={100} ignoreFixedSize />
            </Col>
          </Grid>
        </Col>
        <Col gutter={5} style={{ display: 'flex' }}>
          <Grid direction="column" gutter={5} align="start">
            <Col gutter={5} flex={1}>
              <Separator weight={20} />
              <Text>Axon Enterprise Inc.</Text>
              <Text>17800 N 85TH STREET</Text>
              <Text>SCOTTSDALE, AZ 85255</Text>
              <Text>
                <Link href="mailto:inquiries@axon.com">inquiries@axon.com</Link>
              </Text>
              <Text>
                <Link href="https://www.axon.com">www.axon.com</Link>
              </Text>
              <Text>TIN: 86-0741227</Text>
              <Text>DUNS Number: 832176382</Text>
              <Text>UEI Number: TBW7MGPYURM7s</Text>
            </Col>
            <Col gutter={5}>
              <Text size="h5" semibold>
                BILL TO
              </Text>
              <Text>{billTo}</Text>
              <Text>{billToAddress?.search}</Text>
            </Col>
          </Grid>
        </Col>
        <Col gutter={5} style={{ display: 'flex' }}>
          <Grid direction="column" align="start" gutter={5}>
            <Col width="100%" gutter={5}>
              <Text size="h3" semibold>
                Proforma Invoice
              </Text>
            </Col>
            <Col width="100%" gutter={5}>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Invoice ID</Text>
                </Col>
                <Col flex={1}>
                  <Text></Text>
                </Col>
              </Grid>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Date</Text>
                </Col>
                <Col flex={1}>
                  <Text>{date}</Text>
                </Col>
              </Grid>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Page</Text>
                </Col>
                <Col flex={1}>
                  <Text>1 of 5</Text>
                </Col>
              </Grid>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Sales Order</Text>
                </Col>
                <Col flex={1}>
                  <Text></Text>
                </Col>
              </Grid>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Requisition</Text>
                </Col>
                <Col flex={1}>
                  <Text></Text>
                </Col>
              </Grid>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Your Ref</Text>
                </Col>
                <Col flex={1}>
                  <Text></Text>
                </Col>
              </Grid>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Our Ref</Text>
                </Col>
                <Col flex={1}>
                  <Text>{ourRef}</Text>
                </Col>
              </Grid>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Payment</Text>
                </Col>
                <Col flex={1}>
                  <Text>{payment}</Text>
                </Col>
              </Grid>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Invoice Account</Text>
                </Col>
                <Col flex={1}>
                  <Text>{invoiceAccount}</Text>
                </Col>
              </Grid>
              <Grid direction="row">
                <Col flex={1}>
                  <Text>Terms of Delivery</Text>
                </Col>
                <Col flex={1}>
                  <Text>{termsOfDelivery}</Text>
                </Col>
              </Grid>
            </Col>
            <Col width="100%" gutter={5}>
              <Text size="h5" semibold>
                SHIP TO
              </Text>
              <Text>{shipTo}</Text>
              <Text>{shipToAddress?.search}</Text>
            </Col>
          </Grid>
        </Col>
      </Grid>
    </>
  )
}

export default Header
